/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import type {DatasetCard} from 'common/widgets/demo-selector-modal/dataset/index';

export function template(this: DatasetCard) {
  return (
    <div sel='.dataset'>
      <div attrs={{class: this.attr(`selected`) ? `selected dataset-holder` : `dataset-holder`, elref: `datasetCard`}}>
        <div sel='.image-holder'>
          <div sel='.card-image' attrs={{class: `${this.attr(`img-name`)}`}} />
          <div sel='.sub-text'>{this.attr(`text`)}</div>
        </div>
      </div>
    </div>
  );
}
